<template>
  <div
    class="
      z-999
      sm:z-40
      bg-white
      absolute
      w-full
      h-screen
      mx-auto
      sm:pl-16
      lg:px-20
      right-0
      opacity-95
      overflow-hidden
    "
  >
    <router-link to="/" class="right-0 absolute p-2">
      <img
        src="images/close.png"
        class="bg-el-right p-2 h-10 w-10 rounded-full"
      />
    </router-link>
    <div class="mt-10 flex h-full items-center justify-center">
      <div class="grid sm:grid-cols-2 grid-cols-1">
        <div class="p-4 py-10 text-left">
          <h1 class="text-base text-color-1 font-montserrat font-semibold mb-6">
            Contact Green Energy Park
          </h1>
          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Address:</span> Green energy park R206
            route régionale, Benguérir
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Phone:</span>
            <a
              href="tel:+212537983740"
              target="_blank"
              class="hover:font-semibold"
              >+212537983740</a
            >
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Email:</span>
            <a
              href="mailto:contact@greenenergypark.ma"
              target="_blank"
              class="hover:font-semibold"
              >contact@greenenergypark.ma</a
            >
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Site Internet:</span>
            <a
              href="www.greenenergypark.ma"
              target="_blank"
              class="hover:font-semibold"
              >www.greenenergypark.ma</a
            >
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Address:</span> 16, Rue Amir Sidi
            Mohammed Souissi, Rabat
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Phone:</span>
            <a
              href="tel:+212537983740"
              target="_blank"
              class="hover:font-semibold"
              >+212537983740</a
            >
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Email:</span>
            <a
              href="mailto:contact@iresen.org"
              target="_blank"
              class="hover:font-semibold"
              >contact@iresen.org</a
            >
          </p>

          <p
            class="
              leading-relaxed
              font-montserrat
              text-color-5 text-left text-sm
              whitespace-normal
              align-middle
              font-light
              mb-4
            "
          >
            <span class="font-semibold">Site Internet:</span>
            <a href="www.iresen.org" target="_blank" class="hover:font-semibold"
              >www.iresen.org</a
            >
          </p>
        </div>

        <div class="p-4 py-10 text-left mx-auto">
          <form class="w-full max-w-lg" @submit.prevent="submit">
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3">
                <input
                  placeholder="Enter your full name"
                  class="
                    appearance-none
                    block
                    w-full
                    bg-gray-200
                    text-gray-700
                    border border-gray-200
                    rounded
                    py-3
                    px-4
                    leading-tight
                    focus:outline-none focus:bg-white focus:border-gray-500
                  "
                  type="text"
                  name="name"
                  id="name"
                  required=""
                  v-model="name"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3">
                <input
                  placeholder="Enter your email"
                  class="
                    appearance-none
                    block
                    w-full
                    bg-gray-200
                    text-gray-700
                    border border-gray-200
                    rounded
                    py-3
                    px-4
                    mb-3
                    leading-tight
                    focus:outline-none focus:bg-white focus:border-gray-500
                  "
                  type="email"
                  name="email"
                  id="email"
                  required=""
                  :class="{ email, error: !email.valid }"
                  v-model="email.value"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3">
                <textarea
                  placeholder="Message"
                  class="
                    no-resize
                    appearance-none
                    block
                    w-full
                    bg-gray-200
                    text-gray-700
                    border border-gray-200
                    rounded
                    py-3
                    px-4
                    mb-3
                    leading-tight
                    focus:outline-none focus:bg-white focus:border-gray-500
                    h-48
                    resize-none
                  "
                  name="textarea"
                  id="textarea"
                  required=""
                  v-model="message.text"
                  :maxlength="message.maxlength"
                ></textarea>
                <span class="counter"
                  >{{ message.text.length }} / {{ message.maxlength }}</span
                >
              </div>
            </div>
            <div class="w-full">
              <button
                class="
                  btn-hover-text
                  lg:px-8
                  px-4
                  lg:py-2.5
                  py-1
                  rounded-0
                  overflow-hidden
                  bg-primary
                  inline-block
                  hover:opacity-90
                "
                type="submit"
              >
                <span
                  class="
                    font-montserrat
                    sm:text-sm
                    text-xs
                    px-2
                    py-3
                    text-header
                  "
                  >Envoyer le message</span
                >
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var emailRegExp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export default {
  // the instance state
  data: function () {
    return {
      name: "",
      email: {
        value: "",
        valid: true,
      },
      message: {
        text: "",
        maxlength: 255,
      },
      submitted: false,
    };
  },
  methods: {
    // submit form handler
    submit: function () {
      this.submitted = true;
    },
    // validate by type and value
    validate: function (type, value) {
      if (type === "email") {
        this.email.valid = this.isEmail(value) ? true : false;
      }
    },
    // check for valid email adress
    isEmail: function (value) {
      return emailRegExp.test(value);
    },
    // check or uncheck all
    checkAll: function (event) {
      this.selection.features = event.target.checked ? this.features : [];
    },
  },
  watch: {
    // watching nested property
    "email.value": function (value) {
      this.validate("email", value);
    },
  },
};
</script>